// extracted by mini-css-extract-plugin
export default {"form":"CreateUserModal_form__EQjVO","submitButton":"CreateUserModal_submitButton__p0Ju4"};